<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg2103"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs2107"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath2117"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path2115" /></clipPath></defs><g
     id="g2109"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g2111"><g
         id="g2113"
         clip-path="url(#clipPath2117)"><g
           id="g2119"
           transform="translate(473.4893,106.4102)"><path
             d="M 0,0 V -36.57 H -217.489 V 180.919 H -7.696 c 4.251,0 7.696,-3.446 7.696,-7.697 L 0,34.071"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2121" /></g><g
           id="g2123"
           transform="translate(364.7451,287.3291)"><path
             d="m 0,0 h -25.965 v -57.754 c 0,-3.42 3.616,-5.631 6.66,-4.071 l 17.218,8.826 c 1.31,0.672 2.863,0.672 4.173,0 l 17.218,-8.826 c 3.044,-1.56 6.66,0.651 6.66,4.071 l 0,57.754 z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2125" /></g><g
           id="g2127"
           transform="translate(401.3799,106.4087)"><path
             d="m 0,0 h -73.271 c -2.433,0 -4.407,1.973 -4.407,4.407 v 31.441 c 0,2.434 1.974,4.407 4.407,4.407 H 0 c 2.434,0 4.407,-1.973 4.407,-4.407 V 4.407 C 4.407,1.973 2.434,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2129" /></g><g
           id="g2131"
           transform="translate(147.2554,425.4526)"><path
             d="m 0,0 v -138.12 h 217.49 v 209.8 c 0,4.247 -3.444,7.69 -7.691,7.69 H 7.697 C 3.446,79.37 0,75.924 0,71.673 V 34.071"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2133" /></g><g
           id="g2135"
           transform="translate(256,504.8228)"><path
             d="m 0,0 h -25.965 v -57.755 c 0,-3.42 3.617,-5.63 6.661,-4.07 l 17.218,8.826 c 1.31,0.671 2.862,0.671 4.173,0 l 17.218,-8.826 c 3.043,-1.56 6.66,0.65 6.66,4.07 V 0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2137" /></g><g
           id="g2139"
           transform="translate(292.6348,323.9019)"><path
             d="m 0,0 h -73.27 c -2.434,0 -4.407,1.973 -4.407,4.408 v 31.44 c 0,2.434 1.973,4.407 4.407,4.407 H 0 c 2.435,0 4.407,-1.973 4.407,-4.407 V 4.408 C 4.407,1.973 2.435,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2141" /></g><g
           id="g2143"
           transform="translate(256,69.8398)"><path
             d="m 0,0 h -217.49 v 209.792 c 0,4.251 3.447,7.697 7.697,7.697 H 0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2145" /></g><g
           id="g2147"
           transform="translate(147.2554,287.3291)"><path
             d="m 0,0 h -25.965 v -57.754 c 0,-3.42 3.617,-5.631 6.661,-4.071 l 17.218,8.826 c 1.309,0.672 2.862,0.672 4.172,0 l 17.218,-8.826 c 3.044,-1.56 6.66,0.651 6.66,4.071 V 0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2149" /></g><g
           id="g2151"
           transform="translate(183.8901,106.4087)"><path
             d="m 0,0 h -73.27 c -2.434,0 -4.407,1.973 -4.407,4.407 v 31.441 c 0,2.434 1.973,4.407 4.407,4.407 H 0 c 2.434,0 4.407,-1.973 4.407,-4.407 V 4.407 C 4.407,1.973 2.434,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2153" /></g><g
           id="g2155"
           transform="translate(501.0303,40.6792)"><path
             d="m 0,0 h -490.06 c -2.039,0 -3.691,1.653 -3.691,3.691 v 21.775 c 0,2.038 1.652,3.691 3.691,3.691 H 0 c 2.038,0 3.69,-1.653 3.69,-3.691 V 3.691 C 3.69,1.653 2.038,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2157" /></g><g
           id="g2159"
           transform="translate(470.0488,7.1772)"><path
             d="m 0,0 h -21.818 c -3.227,0 -5.842,2.616 -5.842,5.842 v 27.66 H 5.842 V 5.842 C 5.842,2.616 3.226,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2161" /></g><g
           id="g2163"
           transform="translate(63.77,7.1772)"><path
             d="m 0,0 h -21.819 c -3.226,0 -5.841,2.616 -5.841,5.842 v 27.66 H 5.842 V 5.842 C 5.842,2.616 3.226,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2165" /></g></g></g></g></svg>
</template>
